import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tlicenciagestor'
})
export class TlicenciagestorPipe implements PipeTransform {

  transform(value: any,arg: string): any {
    const resultPost = [];
    for (const post of value) {
      if ( arg === post.tipolicencias) {
       resultPost.push (post);
      } 
   }
    return resultPost;
  }

}
